// ================= ADMIN_LIST =================== //

export const ADMIN_LIST = "ADMIN_LIST";
export const ADMIN_LIST_SUCCESS = "ADMIN_LIST_SUCCESS";
export const ADMIN_LIST_FAIL = "ADMIN_LIST_FAIL";

// ================= ADD_ADMIN_LIST =================== //

export const ADD_ADMIN_LIST = "ADD_ADMIN_LIST";
export const ADD_ADMIN_LIST_SUCCESS = "ADD_ADMIN_LIST_SUCCESS";
export const ADD_ADMIN_LIST_FAIL = "ADD_ADMIN_LIST_FAIL";

// ================= UPDATE_ADMIN_LIST =================== //

export const UPDATE_ADMIN_LIST = "UPDATE_ADMIN_LIST";
export const UPDATE_ADMIN_LIST_SUCCESS = "UPDATE_ADMIN_LIST_SUCCESS";
export const UPDATE_ADMIN_LIST_FAIL = "UPDATE_ADMIN_LIST_FAIL";


// ================= CHANGE PASSWORD =================== //

export const CHANGE_ADMIN_PASSWORD = "CHANGE_ADMIN_PASSWORD";
export const CHANGE_ADMIN_PASSWORD_SUCCESS = "CHANGE_ADMIN_PASSWORD_SUCCESS";
export const CHANGE_ADMIN_PASSWORD_FAIL = "CHANGE_ADMIN_PASSWORD_FAIL";
